<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')">首页</a-breadcrumb-item>
      <a-breadcrumb-item>体检预约</a-breadcrumb-item>
    </a-breadcrumb>
    <!--注意事项-->
    <Collapse :data="vPrecaution"></Collapse>
    <!--注意事项-->

    <!-- 折叠面板 -->
    <div class="tab-content">
      <div>
        <a-space class="school-select">
          <span>体检院区：</span>
          <a-select style="width: 200px" @change="handleChange" v-model="campusName">
            <a-select-option :value="item.name" v-for="item in schoolList" :key="item.campusNo">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-space>
        <a-space class="school-select">
          <span>套餐名称：</span>
          <a-input-search placeholder="搜索套餐名称" @search="onSearch" @change="changeSearch" v-model="searchValue" />
        </a-space>

        <!-- <div class="scroll">
          <div class="list" @scroll="scroll($event)">
            <div
              :class="[activedIndex == index ? 'actived' : '', 'list-item']"
              v-for="(item, index) in comboList"
              :key="item.id"
              @click="onDetail(item, index)"
            >
              <div class="list-pro-name">
                <div class="item-name">{{ item.comboName }}</div>
                <div class="item-time">{{ item.itemList }}</div>
              </div>
            </div>
          </div>
        </div> -->

        <!--套餐列表-->
        <a-menu style="width: 400px" mode="inline" :open-keys.sync="openKeys" v-model="menuKey">
          <a-sub-menu v-for="(item, index) in typeList" :key="index">
            <span slot="title">
              <a-icon type="appstore" />
              <span class="title-typeName">
                {{ item.typeName }}
                <div v-if="item.description">
                  <span class="desc-name">
                    {{ item.description }}
                  </span>
                </div>
              </span>
            </span>

            <a-menu-item v-for="item1 in item.comboList" @click="onDetail(item1, item)" :key="item1.id">
              {{ item1 && item1.comboName }}
              <!--基础项目-->
              <div class="desc-name1" v-if="item1 && item1.basicsItemList.length > 0">
                <a-tag color="" v-for="(item, index) in item1.basicsItemList" :key="index">
                  {{ item.itemName }}
                </a-tag>
              </div>
              <!--基础项目 旧版本-->
              <div class="desc-name1" v-else-if="item1 && item1.basicsItem">
                <a-tag color="" v-for="(item, index) in item1.basicsItem.split(',')" :key="index">
                  {{ item }}
                </a-tag>
              </div>
            </a-menu-item>

            <template v-if="item.childTypeList && item.childTypeList.length > 0">
              <a-menu-item v-for="item2 in item.childTypeList" :key="item2.id" @click="onModalDetail(item2, item)">
                <span class="title-typeName1">
                  {{ item2.typeName }}
                </span>
                <div v-if="item2.description">
                  <span class="desc-name">
                    {{ item2.description }}
                  </span>
                </div>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </a-menu>
        <!--套餐列表-->

        <!--预约记录-->
        <a-card title="已预约" style="width: 400px" v-if="!isNo && listData && listData.length > 0">
          <a-result status="info" title="您有成功预约的体检单!">
            <template #extra>
              <a-button key="console" type="primary" @click="viewMore">
                查看更多
              </a-button>
              <!-- <a-button key="buy" @click="cancelApp">取消预约</a-button> -->
            </template>
            <div class="desc" v-for="(item, index) in listData.slice(0, 1)" :key="index">
              <p>体检院区：{{ item.campusName }}</p>
              <p>体检套餐：{{ item.comboName }}</p>
              <p>
                就诊日期：
                {{ item.appointmentTime }}&nbsp;&nbsp;{{
                  item.timePeriod || ""
                }}
              </p>
            </div>
          </a-result>
        </a-card>

        <!--预约记录-->
      </div>

      <!--体检项目详情-->
      <div class="detail">
        <template v-if="queryParams && queryParams.comboName">
          <div class="detail-title">
            {{ queryParams && queryParams.comboName }}
          </div>
          <div class="detail-content">
            <PanelTitle title="体检项目"> </PanelTitle>
            <h3>基础项目</h3>
            <!--新版-->
            <div class="pd-lf-12" v-if="queryParams && queryParams.basicsItemList.length > 0">
              <p v-for="(item, index) in queryParams.basicsItemList" :key="index">
                {{ index + 1 }}.{{ item.itemName }}
              </p>
            </div>
            <!--旧版-->
            <div class="pd-lf-12" v-else-if="queryParams && queryParams.basicsItem">
              <p v-for="(item, index) in queryParams.basicsItem.split(',')" :key="index">
                {{ index + 1 }}.{{ item }}
              </p>
            </div>
            <!-- <h3>可选项目</h3>
            <div
              class="pd-lf-12"
              v-if="queryParams && queryParams.optionalItemCheckbox"
            >
              <p
                v-for="(item, index) in queryParams.optionalItemCheckbox.split(
                  ','
                )"
                :key="index"
              >
                {{ index + 1 }}.{{ item }}
              </p>
              <div v-if="queryParams.optionalItemRadio">
                <p
                  v-for="(item, index) in queryParams.optionalItemRadio.split(
                    ','
                  )"
                  :key="index"
                >
                  {{
                    queryParams.optionalItemCheckbox.split(",").length
                      ? queryParams.optionalItemCheckbox.split(",").length +
                        index +
                        1
                      : index + 1
                  }}.{{ item }}
                </p>
              </div>
            </div> -->
            <PanelTitle title="体检中心"></PanelTitle>
            <!--  -->
            <div>
              <div class="top clearfix">
                <div class="top-left fl">
                  <div class="tlt clearfix flex-between">
                    <span class="title1 fl" @click="onChangeMonth(-1)">上月</span>
                    <div class="block center">
                      <a-month-picker v-model="value" @change="changeDate" :allowClear="false" valueFormat="YYYY-MM"
                        placeholder="选择月份" />
                    </div>
                    <span class="title1 fr" @click="onChangeMonth(1)">下月</span>
                  </div>
                  <Calendar :defaultMonth.sync="defaultMonth" :campusName="campusName" :campusId="campusId"
                    :queryParams="queryParams" :userInfo1="userInfo1"></Calendar>
                </div>
              </div>
            </div>
            <!--  -->
            <PanelTitle title="特别说明"> </PanelTitle>
            <div class="pd-lf-12">
              <p class="remark">{{ (queryParams && queryParams.remark) || "" }}</p>
            </div>
          </div>
        </template>

        <!--空状态-->
        <a-empty class="empty-data" description="请选择套餐" v-else />
      </div>

      <!--体检项目详情-->
    </div>

    <!--附加-->
    <a-modal v-model="MenuModalVisible" :title="`附加-${modalTypeActive.typeName}`" :footer="null"
      :dialog-style="{ top: '20%' }" width="450px">
      <div v-if="!empty">
        <a-menu style="width: 400px" mode="inline" :open-keys.sync="openKeys1" :default-selected-keys="[activedIndex1]">
          <a-sub-menu v-for="(item, index) in typeList1" :key="index">
            <span slot="title">
              <a-icon type="appstore" />
              <span class="title-typeName">
                {{ item.typeName }}
                <div v-if="item.description">
                  <span class="desc-name">
                    {{ item.description }}
                  </span>
                </div>
              </span>
            </span>
            <a-menu-item @click="onDetail1(item1, item)" v-for="item1 in item.comboList" :key="item1.id">
              {{ item1 && item1.comboName }}
              <!--基础项目-->
              <div class="desc-name1" v-if="item1 && item1.basicsItemList.length > 0">
                <a-tag color="" v-for="(item, index) in item1.basicsItemList" :key="index">
                  {{ item.itemName }}
                </a-tag>
              </div>
              <!--基础项目 旧版本-->
              <div class="desc-name1" v-else-if="item1 && item1.basicsItem">
                <a-tag color="" v-for="(item, index) in item1.basicsItem.split(',')" :key="index">
                  {{ item }}
                </a-tag>
              </div>
            </a-menu-item>
            <template v-if="item.childTypeList && item.childTypeList.length > 0">
              <a-menu-item v-for="item2 in item.childTypeList" :key="item2.id" @click="onModalDetail(item2, item)">
                <span class="title-typeName1">
                  {{ item2.typeName }}
                </span>
                <div v-if="item2.description">
                  <span class="desc-name">
                    {{ item2.description }}
                  </span>
                </div>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </a-menu>
      </div>
      <div v-else>
        <a-empty description="当前标题暂无套餐" class="auto-m" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import Calendar from "@/components/Calendar/Calendar.vue";
import PanelTitle from "@/components/panel-title";
import Collapse from "@/components/Collapse";
import base from "@/assets/base/base.js";
import {
  getTypeComboList,
  getComboNo,
  getReserveList,
  getPrecautions,
  getMemberUser,
} from "@/api/medicalBooking";
import { getWeekDate } from "@/utils/index";
import moment from "moment";
import {
  getAllotComboCalendar,
  allotComboCalendar,
} from "@/api/medicalBooking";
/**
 * 如果两个字符串中的字符具有相同的字符，则此方法将返回true 否则false。
 */
function hasSameCharacter(str1, str2) {
  if (str1 && str1.indexOf(str2) >= 0) {
    return true;
  } else {
    return false;
  }
}
export default {
  components: {
    PanelTitle,
    Calendar,
    Collapse,
  },
  data() {
    return {
      isNo: false,
      listData: [], //预约记录
      MenuModalVisible: false,
      menuKey: [],
      openKeys: [],
      openKeys1: [],
      searchValue: "",
      vPrecaution: "",
      value: moment(new Date(), "YYYY-MM"),
      defaultMonth: new Date(),

      campusName: "华家池院区",
      campusId: "10366",

      schoolList: [
        // { name: '西溪院区', campusNo: '10219' ,title:'西溪'},
        { name: "华家池院区", campusNo: "10366", title: "华家池" },
        { name: "紫金港院区", campusNo: "10393", title: "紫金港" },
        { name: "玉泉院区", campusNo: "10215", title: "玉泉" },
      ],
      activedIndex: "",
      activedIndex1: "",
      comboNoList: [],
      queryParams: {},
      page: 1,
      isLoading: true,
      userInfo: {},
      applyPersonnelType: {
        1: "在职",
        2: "在校学生",
        3: "退休",
        4: "校外人员",
        5: "其他",
      },
      typeList: [],
      typeList1: [],
      modalTypeActive: {},
      empty: false,
      userInfo1: {},
    };
  },
  async created() {
    base.isMaritalStatusAndCountry()
    //获取注意事项
    this.getPrecautionsApi();

    this.userInfo =
      sessionStorage.getItem("userInfo") &&
      JSON.parse(sessionStorage.getItem("userInfo"));

    //获取名单数据
    await this.getMemberUserInfo();

    const school = this.schoolList.find((item) => {
      if (hasSameCharacter(this.userInfo.college, item.title)) {
        return item;
      } else {
        return null;
      }
    });

    //获取院区套餐分类
    if (school && school.name) {
      await this.handleChange(school.name);
    } else {
      await this.handleChange("华家池院区");
    }
  },
  beforeDestroy() {
    this.$notification.destroy();
  },
  methods: {
    /**查看更多 */
    viewMore() {
      this.$router.push({
        path: "/myRegistration",
        query: { queryActived: 1 },
      });
    },
    /**取消预约 */
    cancelApp() {
      this.$confirm({
        title: "取消预约",
        content: "取消预约请联系体检老师",
        onOk() {
          console.log("OK");
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    },
    /**体检预约记录**/
    async getReserve() {
      const params = {
        name: this.userInfo1.name,
        phone: this.userInfo1.phone,
        idNumber: this.userInfo1.idNumber, //证件号
        pageNum: 1, //页码 默认为1
        pageSize: 10, //每页记录数 默认为10
        encrVa:base.encryptAES(this.userInfo1.name+this.userInfo1.idNumber+this.userInfo.userNo),//加密字段
      };
      const { code, data } = await getReserveList(params);
      if (code == 200) {
        let listData = data || [];
        this.listData = listData.filter((e) => {
          return e.status === 0 && this.comparisonTime(e.appointmentTime); //已预约 & 预约时间大于等于今天
        });
        if (this.listData.length > 0) {
          this.isNo = false;
        } else {
          this.isNo = true;
        }
      } else {
        this.isNo = true;
        this.listData = [];
      }
    },
    /**比较时间
     * 大于等于当前时间
     * yyyy-mm-dd-》时间戳
     */
    comparisonTime(val) {
      let currentDate = new Date().getTime();
      let isTime = base.getTimestamp(val);
      if (isTime >= currentDate) {
        return true;
      } else {
        false;
      }
    },
    /**名单数据 */
    async getMemberUserInfo() {
      const params = {
        ...this.userInfo,
      };
      const { code, data } = await getMemberUser(params);
      if (code == 200) {
        if (data) {
          this.userInfo1 = { ...data };
          base.isMaritalStatusAndCountry2(this.userInfo1)
        } else {
          this.userInfo1 = {};
        }
        //体检预约记录
        this.getReserve();
      }
    },
    /**获取院区套餐可预约日期 */
    async getData() {
      if (this.queryParams.id && this.campusId) {
        const params = {
          comboId: this.queryParams && this.queryParams.id,
          currentDate: "",
          campusId: this.campusId,
          gender: this.userInfo1.gender, //性别 1男 2女 3通用
        };
        const { code, data } = await allotComboCalendar(params);
        if (code == 200) {
          let allotDate = data && data[0].allotDate;
          allotDate = base.getTimestamp(allotDate);
          //将最近的可预约日期设置为默认月
          this.defaultMonth = (allotDate && new Date(allotDate)) || new Date();
          this.value = moment(this.defaultMonth).format("YYYY-MM");
        } else {
          this.defaultMonth = new Date();
          this.value = moment(this.defaultMonth).format("YYYY-MM");
        }
      }
    },
    onSearch(value) {
      this.getComboList();
    },
    changeSearch(e) {
      if (e.target.value == "") {
        this.getComboList();
      }
      console.log(e.target.value);
    },
    getAge(val) {
      let currentYear = new Date().getFullYear(); //当前的年份
      let calculationYear = new Date(val).getFullYear(); //计算的年份
      const wholeTime = currentYear + val.substring(4); //周岁时间
      const calculationAge = currentYear - calculationYear; //按照年份计算的年龄
      //判断是否过了生日
      if (new Date().getTime() > new Date(wholeTime).getTime()) {
        return calculationAge;
      } else {
        return calculationAge - 1;
      }
    },
    analyzeIDCard(IDCord) {
      var sexAndAge = null;
      //获取用户身份证号码
      var userCard = IDCord;
      //如果用户身份证号码为undefined则返回空
      if (!userCard) {
        return sexAndAge;
      }

      // 获取出生日期
      // userCard.substring(6,10) + "-" + userCard.substring(10,12) + "-" + userCard.substring(12,14)
      var yearBirth = userCard.substring(6, 10);
      var monthBirth = userCard.substring(10, 12);
      var dayBirth = userCard.substring(12, 14);
      // 获取当前年月日并计算年龄
      var myDate = new Date();
      var monthNow = myDate.getMonth() + 1;
      var dayNow = myDate.getDate();
      var age = myDate.getFullYear() - yearBirth;
      if (
        monthNow < monthBirth ||
        (monthNow == monthBirth && dayNow < dayBirth)
      ) {
        age--;
      }
      // 得到年龄
      sexAndAge = age;
      // 返回 性别和年龄
      return sexAndAge;
    },
    handleClick(e) {
      console.log("click", e);
    },
    titleClick(e) {
      console.log("titleClick", e);
    },
    /**获取注意事项 */
    async getPrecautionsApi() {
      const { code, data } = await getPrecautions();
      if (code == 200) {
        this.vPrecaution = data;
      }
    },
    onChangeMonth(num) {
      if (num == -1) {
        this.value = moment(this.value).subtract(1, "months").format("YYYY-MM");
      } else {
        this.value = moment(this.value).add(1, "months").format("YYYY-MM");
      }
      this.changeDate();
    },
    changeDate() {
      this.defaultMonth = new Date(base.getTimestamp(this.value));
    },
    /** 院区切换*/
    handleChange(value, option) {
      this.campusName = value;
      this.campusId = this.schoolList.find(
        (item) => item.name == value
      ).campusNo;
      this.getComboList();
      this.activedIndex = "";
      this.activedIndex1 = "";
      this.queryParams = {};
      this.menuKey = [];
      this.openKeys = [];
      this.openKeys1 = [];
    },

    onDetail(data, typeData) {
      this.activedIndex = data.id;
      this.queryParams = {
        ...data,
      };
      console.log(data);
      sessionStorage.setItem("comboTitle", `${typeData.typeName}`);
      this.getData();
    },
    onDetail1(data, typeData) {

      this.activedIndex1 = data.id;
      this.queryParams = {
        ...data,
      };
      this.MenuModalVisible = false;
      this.getData();
    },
    /**
     * 获取院区套餐分类列表
     */
    async getComboList() {
      const age = this.getAge(this.userInfo1.birthday);
      this.typeList = [];
      const params = {
        comboName: this.searchValue, //套餐名称
        applyCampus: this.campusName,
        applyPersonnelType: this.applyPersonnelType[this.userInfo1.memberType],
        applyTitle: this.userInfo1.title,
        genderRestrictions: this.userInfo1.gender, //性别 1男 2女 3通用
        age: age, //服务年龄
        marriageRestrictions: this.userInfo1.maritalStatus, //婚姻状况
        // pageNum: 1, //页码 默认为1
        // pageSize: 10 //每页记录数 默认为10
      };
      const { code, data } = await getTypeComboList(params);

      if (code == 200) {
        this.typeList = data || [];

        const list = this.typeList.find((item) => item.comboList.length > 0);
        const findIndex = this.typeList.findIndex(
          (item) => item.comboList.length > 0
        );
        //this.openKeys = [findIndex];
        if (list && list.comboList.length > 0) {
          //this.queryParams = list;
          //this.onDetail(list.comboList[0], list);
        }
      }
    },

    onModalDetail(item2) {
      this.MenuModalVisible = false;
      this.queryParams = {};
      sessionStorage.setItem(
        "comboTitle",
        `${item2.parentName}/${item2.typeName}`
      );
      this.modalTypeActive = {
        ...item2,
      };
      this.getComboList1(item2);
    },

    async getComboList1(modalDetail) {
      const age = this.getAge(this.userInfo1.birthday);
      const params = {
        comboName: this.searchValue, //套餐名称
        applyCampus: this.campusName,
        applyPersonnelType: this.applyPersonnelType[this.userInfo1.memberType],
        applyTitle: this.userInfo1.title,
        genderRestrictions: this.userInfo1.gender, //性别 1男 2女 3通用
        age: age, //服务年龄
        typeId: modalDetail.id,
        marriageRestrictions: this.userInfo1.maritalStatus, //婚姻状况
        // pageNum: 1, //页码 默认为1
        // pageSize: 10 //每页记录数 默认为10
      };
      const { code, data } = await getTypeComboList(params);
      if (code == 200) {
        this.typeList1 = data || [];

        const list = this.typeList1.find((item) => item.comboList.length > 0);
        const findIndex = this.typeList1.findIndex(
          (item) => item.comboList.length > 0
        );
        // this.openKeys1 = [findIndex];
        if (list && list.comboList.length > 0) {
          this.queryParams = list;
          this.onDetail1(list.comboList[0], list);
        }
        const childList = this.typeList1.find(
          (item) => item.childTypeList.length > 0
        );
        if (
          (list && list.comboList.length > 0) ||
          (childList && childList.childTypeList.length > 0)
        ) {
          this.empty = false;
        } else {
          this.empty = true;
        }
        setTimeout(() => {
          this.MenuModalVisible = true;
        }, 200);
      }
    },

    // //滚动分页加载数据
    // async scroll(e) {
    //   // let isLoading = true //是否有数据可以加载
    //   // 距离底部200px时加载一次
    //   if (e) {
    //     let bottomOfWindow =
    //       e.srcElement.offsetHeight +
    //         e.srcElement.scrollTop -
    //         e.srcElement.scrollHeight <
    //       10
    //     if (bottomOfWindow && this.isLoading == true) {
    //       this.page = this.page + 1 //每次分页+1
    //       const params = {
    //         comboName: '', //套餐名称
    //         applyCampus: this.campusName,
    //         applyPersonnelType: this.applyPersonnelType[this.userInfo.userType],
    //         gender: this.userInfo.gender, //性别 1男 2女 3通用
    //         age: this.userInfo.age, //服务年龄
    //         pageNum: this.page, //页码 默认为1
    //         pageSize: 10 //每页记录数 默认为10
    //       }
    //       const { data, code } = await getList(params)
    //       //有数据的时候加载
    //       if (data.length > 0) {
    //         this.comboList.push(...data) //追加数据 使用 ...语法
    //         this.isLoading = true
    //       } else {
    //         this.isLoading = false //无数据可以加载
    //       }
    //     }
    //   }
    // },
    doConfirmation(item) {
      const params = {
        ...item,
        ...this.queryParams,
        campusName: this.campusName,
      };
      this.$router.push({
        path: "/confirmation",
        query: {
          type: "physical",
          physicalParams: JSON.stringify(params),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-between {
  display: flex;
  justify-content: space-between;
}

.school-select {
  padding-left: 24px;
  margin-bottom: 12px;
  margin-top: 12px;

  span {
    font-size: 14px;
  }
}

.pd-lf-12 {
  padding-left: 12px;

  p {
    color: #666;
    letter-spacing: 2px;
  }

  .remark {
    font-weight: bold;
    color: red !important;
  }
}

.container {
  .tab-content {
    display: flex;
    justify-content: space-between;

    .list {
      border: 1px solid #e8e8e8;
      padding: 16px;
    }

    h3 {
      font-size: 16px;
    }

    .scroll {
      width: 325px;
      height: 680px;

      .list {
        overflow-y: auto;
        overflow-x: hidden;
        width: 325px;
        height: 680px;
        background: inherit;
        background-color: rgba(255, 255, 255, 1);

        .list-item {
          display: flex;
          margin-bottom: 16px;
          padding-bottom: 16px;
          border-bottom: 1px solid #e8e8e8;
          cursor: pointer;

          img {
            width: 55px;
            height: 55px;
            margin-right: 12px;
          }

          .list-pro-name {

            .item-name,
            .item-time {
              margin: 4px;
              font-size: 16px;
              width: 252px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }

    .detail {
      width: 835px;
      background: inherit;
      background-color: rgba(255, 255, 255, 1);
      border: 1px solid #e8e8e8;

      .detail-title {
        padding: 25px;
        font-weight: bold;
        font-size: 18px;
        letter-spacing: 2px;
        background: #f8f8f8;
      }
    }
  }

  .detail {
    .detail-title {
      border-bottom: 1px solid #e8e8e8;
    }

    .detail-content {
      padding: 20px;
    }
  }
}

.tag-item {
  margin: 2px;
}

.week {
  display: flex;
  position: relative;
  border: 1px solid #f8f8f8;
  margin-left: 12px;

  .week-now {
    width: 34px;
    background-color: rgba(230, 236, 245, 1);
    font-size: 14px;
    padding: 0 5px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .week-now-time {
    width: 873px;

    .item {
      background-color: #faf7fa;
      box-sizing: border-box;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(248, 248, 248, 1);
      border-radius: 0px;
      display: flex;
      justify-content: space-between;
      padding: 12px 32px;

      >span {
        font-size: 14px;
      }
    }
  }
}

.actived {
  border-bottom: 2px solid #3f86ff !important;
  background-color: rgba(63, 134, 255, 0.07) !important;
}

.clearfix::before,
.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.title1 {
  color: #1890ff;
  font-size: 16px;
  font-weight: 900;
  cursor: pointer;
}

.top-left {
  width: 70%;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;

  &>.tlt {
    line-height: 40px;
    padding-bottom: 10px;
  }
}

/deep/ .ant-menu-submenu-title {
  height: auto !important;
}

/deep/ .ant-menu-sub.ant-menu-inline>.ant-menu-item,
.ant-menu-sub.ant-menu-inline>.ant-menu-submenu>.ant-menu-submenu-title {
  height: auto !important;
}

/deep/ .title-typeName {
  font-weight: 700;
  color: #000000d9;
}

/deep/ .title-typeName1 {
  font-size: 15px;
  color: #000000d9;
}

/deep/ .desc-name {
  width: 100%;
  font-size: 13px;
  white-space: pre-wrap;
  color: #00000073;
}

/deep/ .desc-name1 {
  width: 100%;
  font-size: 12px;
  white-space: pre-wrap;
}

.empty-data {
  margin: 40px auto;
}
</style>
